export type Article = {
  title: string;
  date: string;
  excerpt: string;
  slug: string;
};

export const articles: Article[] = [
  {
    title: "Терапевтический контракт: как создаётся пространство для изменений?",
    date: "26.05.2025",
    excerpt:
      "Почему терапия — это не просто разговор, а структурированный процесс с чёткими границами и профессиональными отношениями.",
    slug: "therapeutic-contract",
  },
  {
    title: "Хроническая боль: симптомы, причины и подходы к лечению",
    date: "23.05.2025",
    excerpt:
      "Хроническая боль — стойкие или повторяющиеся болевые ощущения более трёх месяцев, затрагивающие сенсорные и эмоциональные функции.",
    slug: "hronicheskaja-bol-simptomy-prichiny-i-podhody-k-lecheniju",
  },
  {
    title: "Что такое гнев и раздражительность: причины, проявления и способы справиться",
    date: "21.05.2025",
    excerpt:
      "О том, когда гнев и раздражительность становятся чрезмерными, и как работать с внутренним напряжением.",
    slug: "chto-takoe-gnev-i-razdrazhitelnost-prichiny-projavlenija-i-sposoby-spravitsja",
  },
  {
    title: "Профессиональное выгорание: основные рекомендации",
    date: "12.06.2025",
    excerpt:
      "Выгорание — не просто усталость, а состояние, когда психика больше не справляется с внутренними конфликтами и ожиданиями.",
    slug: "professionalnoe-vygoranie-osnovnye-rekomendacii",
  },
  {
    title: "Сопротивление в психотерапии: механизмы избегания изменений",
    date: "06.06.2025",
    excerpt:
      "Почему сопротивление в терапии — нормальный процесс, и как его осознавать для продвижения вперёд.",
    slug: "soprotivlenie-v-psihoterapii-mehanizmy-izbeganija-izmenenij",
  },
  {
    title: "Что же такое депрессия?",
    date: "30.05.2025",
    excerpt:
      "Как распознать депрессивное состояние, чем оно отличается от обычной грусти, и когда нужна помощь специалиста.",
    slug: "what-is-depression",
  },
  {
    title: "Когда стоит обратиться к психотерапевту",
    date: "28.04.2025",
    excerpt:
      "О телесных симптомах, мифах о лечении и важности раннего обращения за психологической помощью.",
    slug: "kogda-stoit-obratitsja-k-psihoterapevtu-o-signalah-tela-i-mifah-o-lechenii",
  },
  {
    title: "Паническая атака: симптомы, диагноз и лечение",
    date: "01.05.2025",
    excerpt:
      "Интенсивный приступ тревоги с соматическими проявлениями. Как распознать и что делать.",
    slug: "panicheskaja-ataka-simptomy-diagnoz-i-lechenie",
  },
  {
    title: "Инсульт: виды, причины, как его распознать и не пропустить?",
    date: "30.12.2022",
    excerpt:
      "Острое нарушение мозгового кровообращения: ключевые признаки, факторы риска и необходимость быстрой реакции.",
    slug: "insult-vidy-prichiny-simptomy-lechenie",
  },
  {
    title: "Боль, онемение и покалывание в ноге",
    date: "30.09.2021",
    excerpt:
      "Почему возникают боли и парестезии в ноге, как отличить опасные симптомы и какие методы лечения эффективны.",
    slug: "bol-onemenie-i-pokalyvanie-v-noge",
  },
  {
    title: "Правильный образ жизни помогает сохранить здоровье спины",
    date: "29.04.2019",
    excerpt:
      "Как привычки и активность влияют на риски неврологических и ортопедических проблем, и что защищает спину.",
    slug: "pravilnyy-obraz-zhizni-pomogaet-sokhr",
  },
  {
    title: "Упражнения при болях в шее и грудном отделе",
    date: "27.09.2018",
    excerpt:
      "Подбор упражнений только после диагноза и согласования с неврологом: когда гимнастика помогает, а когда может навредить.",
    slug: "uprazhneniya-pri-bolyakh-v-shee-i-grudnom-ot",
  },
  {
    title: "Боль в лице",
    date: "27.02.2022",
    excerpt:
      "Что такое прозопалгия, как лицевые боли влияют на качество жизни и какие подходы к диагностике и лечению применяются.",
    slug: "bol-v-lice",
  },
  {
    title: "Профилактическая гимнастика",
    date: "26.09.2018",
    excerpt:
      "Реабилитационные мероприятия при боли в спине: как правильно выполнять упражнения с учётом диагноза.",
    slug: "profilakticheskaya-gimnastika",
  },
  {
    title: "Что же такое неврология?",
    date: "26.08.2022",
    excerpt:
      "Простыми словами о том, что изучает неврология и почему это одна из самых сложных клинических областей.",
    slug: "what-is-neurology",
  },
  {
    title: "Радикулопатия: причины, симптомы, методы диагностики и лечения",
    date: "26.03.2022",
    excerpt:
      "Почему возникает радикулопатия, в каких отделах позвоночника бывает и как её лечат.",
    slug: "radikulopatija-prichiny-simptomy-i-metody-diagnostiki",
  },
  {
    title: "Постковидный синдром",
    date: "26.02.2022",
    excerpt:
      "Состояние после перенесённой коронавирусной инфекции: возможные симптомы и подходы к восстановлению.",
    slug: "postkovidnyj-sindrom",
  },
  {
    title: "Мигрень: причины, симптомы и лечение",
    date: "24.11.2018",
    excerpt:
      "Приступы пульсирующей головной боли: клинические особенности, диагностика и терапия.",
    slug: "vse-chto-vam-nuzhno-znat-o-migreni",
  },
  {
    title: "Шаткость при ходьбе: основные причины, принципы диагностики и лечения",
    date: "24.08.2022",
    excerpt:
      "Почему появляется шаткость, когда это опасно и какие обследования нужны.",
    slug: "shatkost-pri-hodbe-osnovnye-prichiny",
  },
  {
    title: "Боль в шее: возможные причины, методы диагностики лечения",
    date: "31.10.2018",
    excerpt:
      "Эпизодические и постоянные боли в шее: типовые причины и подходы к лечению.",
    slug: "boli-v-shee-vozmozhnye-prichiny-i-lechenie",
  },
];
